var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import * as React from 'react';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import { Divider, Container, Typography } from '@mui/material';
import RoasterEditForm from '../../RoasterEditForm';
var Wrapper = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  margin: 20px 30px;\n"], ["\n  margin: 20px 30px;\n"])));
var ProfileContent = function (_a) {
    var roaster = _a.roaster, onUpdate = _a.onUpdate;
    var t = useTranslation().t;
    return (React.createElement(Wrapper, null,
        React.createElement(Container, { maxWidth: "md" },
            React.createElement(Typography, { variant: "h6" }, t('pages.editProfile.subTitle')),
            React.createElement(Divider, null),
            React.createElement(RoasterEditForm, { roaster: roaster, onUpdate: onUpdate, admin: true }))));
};
export default ProfileContent;
var templateObject_1;
